export default "__VITE_ASSET__DSrh96aJ__"